var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#E6F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11C15.3431 11 14 12.3431 14 14C14 15.6569 15.3431 17 17 17C18.6569 17 20 15.6569 20 14C20 12.3431 18.6569 11 17 11ZM12.1 13C12.5633 10.7178 14.581 9 17 9C19.419 9 21.4367 10.7178 21.9 13H30C30.5523 13 31 13.4477 31 14C31 14.5523 30.5523 15 30 15H21.9C21.4367 17.2822 19.419 19 17 19C14.581 19 12.5633 17.2822 12.1 15H10C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13H12.1ZM26 23C24.3431 23 23 24.3431 23 26C23 27.6569 24.3431 29 26 29C27.6569 29 29 27.6569 29 26C29 24.3431 27.6569 23 26 23ZM21.1 25C21.5633 22.7178 23.581 21 26 21C28.7614 21 31 23.2386 31 26C31 28.7614 28.7614 31 26 31C23.581 31 21.5633 29.2822 21.1 27H10C9.44772 27 9 26.5523 9 26C9 25.4477 9.44772 25 10 25H21.1Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.5f4afdf8.svg";
export { ForwardRef as ReactComponent };